import React, { FC, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { QueryParams } from '@src/containers/Source/interfaces/queryParams.interface';
import { createLink } from '@src/util/createLink';
import { MetricAction, MetricContext } from '@src/metrics/metrics.enum';
import { FEATURED_APPLICANTS_ROUTE } from '@src/Routes/links';
import { Button } from '@src/components/Button';
import { useQueryParams } from '@src/customHooks/useQueryParams';
import { trackEvent } from '@src/metrics';
import { PlacesSearch } from '../SearchSection/PlacesSearch';
import { KeywordSearch } from '../SearchSection/KeywordSearch';
import './styles.scss';

export const Header: FC = () => {
  const history = useHistory();

  const { queryParams: urlQueryParams } = useQueryParams<QueryParams>();
  const { place } = urlQueryParams;

  const [queryParams, updateQueryParams] = useState<QueryParams>(urlQueryParams);

  const { searchPatterns = [] } = queryParams;

  const onSearch = () => {
    history.push(
      createLink(FEATURED_APPLICANTS_ROUTE, {
        queryParams: { ...queryParams },
      }),
    );

    trackEvent({
      context: MetricContext.SOURCING_ENTRY_PAGE,
      interaction: MetricAction.OPEN_SOURCE,
      payload: {
        'Country or City':
          (queryParams.place?.name || '') + !!queryParams?.isRemote
            ? ', Remote'
            : '' + !!queryParams?.isRelocation
            ? ', Relocation'
            : '',
        'SearchPatterns': queryParams?.searchPatterns?.map(pattern => pattern.pattern).join(', '),
      },
    });
  };

  return (
    <div className="featured-talent-header">
      <div className="featured-start-headhunt-search__fields-keyword">
        <KeywordSearch
          onQueryParamsSelect={queryParams => updateQueryParams(queryParams)}
          onSelect={searchPatterns => updateQueryParams(prev => ({ ...prev, searchPatterns }))}
          queryParams={queryParams}
          values={searchPatterns}
        />
      </div>

      <div className="featured-start-headhunt-search__fields-country">
        <PlacesSearch
          onClear={() => {
            updateQueryParams(prev => ({ ...prev, place: undefined }));
          }}
          onPlaceSelect={place => updateQueryParams(prev => ({ ...prev, place }))}
          selectedPlace={place}
        />
      </div>

      <div className="featured-start-headhunt-search__fields-button">
        <Button className="featured-start-headhunt-search__browse" onClick={onSearch}>
          Browse
        </Button>
      </div>
    </div>
  );
};
